module.exports = __webpack_public_path__ + "static/media/totem2.cce63342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Totem/totem2.jpg
// module id = 360
// module chunks = 0